import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Dropdown, notification, Select, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import DeleteConfirmation from "../../../components/common/ConfirmationModal/DeleteConfirmation";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import VideoFilm from "../../../components/icons/VideoFilm";
import VideoGroup from "../../../components/icons/VideoGroup";
import { addClient } from "../../../utils/validations";
import EditTenant from "./EditClient";
const AddClients = ({ ...props }) => {
  const firstRef = useRef(true);
  const secRef = useRef(true);
  const { Option } = Select;
  const {
    addTenant,
    getTenant,
    tenantNames,
    setTenantNames,
    getUserDetail,
    deleteTenant,
    setTenantDetails,
    tenantDetails,
    usersDetails,
    setUsersDetails,
    userSearch,
    setUserSearch,
    loder,
    updateTenant,
  } = props;
  const [isTenantModalOpen, setIsTenantModalOpen] = useState(false);
  const [editmodalOpen, setEditModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [count, setCount] = useState(0);
  const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;

  const openModal = () => {
    setIsTenantModalOpen(true);
    setInitialValues({ name: "", clientId: [] });
    setUserSearch([]);
  };
  const closeModal = () => {
    setIsTenantModalOpen(false);
    setUserSearch([]);
    setInitialValues({
      name: "",
    });
  };

  const [initialValues, setInitialValues] = useState({
    name: "",
    clientId: [],
  });

  const setTenantName = (e, setFieldValue) => {
    setFieldValue("name", e);
    setInitialValues({ ...initialValues, name: e });
  };
  const getTenants = async () => {
    const data = await getTenant();
    if (data?.value?.success) {
      setTenantNames(data?.value?.data);
    }
  };
  const handleSubmit = async ({ name }) => {
    const data = await addTenant({
      name,
      associateUsers: userSearch,
    });
    if (data.value.success) {
      notification["success"]({ message: data.value.message });
    } else {
      notification["error"]({ message: data.value.message });
    }

    setInitialValues({ name: "", clientId: [] });
    setUserSearch([]);
    closeModal();
    getTenants();
  };

  const editOpen = () => {
    setEditModalOpen(true);
  };

  const delOpen = () => {
    setDeleteModalOpen(true);
  };
  const actions = {
    edit_clients: true,
    delete_clients: true,
  };

  useEffect(() => {
    getTenants();
  }, []);
  const handleTenantTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "edit_clients":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    editOpen();
                  }}
                >
                  <VideoFilm />
                  <span>Edit</span>
                </a>
              ),
              key: "1",
            });
            break;
          case "delete_clients":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    delOpen();
                  }}
                >
                  <DeleteIcon />
                  <span>Delete</span>
                </a>
              ),
              key: "2",
            });
            break;
        }
      }
    }
  };

  const deleteFunction = async () => {
    const data = await deleteTenant({ id: tenantDetails._id, associateUsers: tenantDetails?.associateUsers });
    if (data.value.success) {
      notification["success"]({ message: data.value.message });
      getTenants();
    } else {
      notification["error"]({ message: data.value.message });
    }
    setDeleteModalOpen(false);
  };
  const handleSubClient = async (e, setFieldValue) => {
    setFieldValue("clientId", e);
    setUserSearch(e);
    const data = await getUserDetail();
    if (data.value.success) {
      const filterUser = data.value.users.filter((d) => !d.hasOwnProperty("clientId"));
      setUsersDetails(filterUser);
    }
  };
  const search = async () => {
    const data = await getUserDetail({ search: searchText });
    if (data.value.success) {
      const filterUser = data.value.users.filter((d) => !d.hasOwnProperty("clientId"));
      setUsersDetails(filterUser);
    }
  };
  useEffect(() => {
    if (firstRef.current) {
      search();
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        search();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [count]);
  useEffect(() => {
    if (secRef.current) {
      secRef.current = false;
    } else {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [searchText, setCount]);

  return (
    <>
      <EditTenant
        editmodalOpen={editmodalOpen}
        setEditModalOpen={setEditModalOpen}
        tenantDetails={tenantDetails}
        tenantNames={tenantNames}
        usersDetails={usersDetails}
        setUsersDetails={setUsersDetails}
        updateTenant={updateTenant}
        getTenants={getTenants}
        getUserDetail={getUserDetail}
        userSearch={userSearch}
        setUserSearch={setUserSearch}
      />
      <DeleteConfirmation
        deleteConfirmModalOpen={deleteModalOpen}
        setDeleteConfirmModalOpen={setDeleteModalOpen}
        tenantDetails={tenantDetails}
        deleteFunction={deleteFunction}
      />
      <Modal
        isOpen={isTenantModalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <AccessControl code="add_folder" page="organization-profile">
            <div className="react-modal-header">
              <h5 className="react-modal-title">Add Client</h5>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </AccessControl>
          <Formik initialValues={initialValues} validationSchema={addClient} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Client Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="name"
                        onChange={(e) => setTenantName(e.target.value, setFieldValue)}
                      />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Users <span className="required">*</span>
                      </label>
                      <Field
                        // showSearch
                        className="custom-ant-select"
                        name="clientId"
                        onChange={(value) => handleSubClient(value, setFieldValue)}
                        placeholder="Select Client"
                        component={Select}
                        mode="multiple"
                        filterOption={false}
                        onSearch={(inputValue) => setSearchText(inputValue)}
                        dropdownStyle={{ zIndex: 99999999 }}
                        value={userSearch}
                        //notFoundContent={secRef.current = false && <Spin indicator={antIcon} />}
                        // value={userSearch}
                      >
                        {usersDetails?.length &&
                          usersDetails.map((data, index) => {
                            return (
                              data.role === "admin" && (
                                <>
                                  <Option key={data._id} value={data.userId}>
                                    {data.name}-{data.email}
                                  </Option>
                                </>
                              )
                            );
                          })}
                      </Field>
                      {touched.clientId && errors.clientId && <div className="invalid-feedback">{errors.clientId}</div>}
                    </div>
                    <button className="btn btn-primary" type="submit">
                      Add
                      {loder === true ? <Spin indicator={antIcon} /> : ""}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <div className="col-md-9">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Clients</h4>
          </div>
          <div className="right-btn-block">
            <div class="button-container">
              <button class="btn btn-primary" onClick={openModal}>
                Add Client
              </button>
            </div>
          </div>
        </div>
        <br />
        <div className="configuration-items-row mt-3 row">
          {tenantNames?.map((data) => {
            return (
              <>
                <div className="col-md-2">
                  <div className="configuration-column pb-0">
                    <Dropdown
                      onClick={() => {
                        setTenantDetails(data);
                      }}
                      className=""
                      overlay={
                        <AccessControl
                          code="menuItem"
                          page="organization-profile"
                          handleTableAction={handleTenantTableAction}
                        />
                      }
                      trigger={["click"]}
                      overlayClassName={"tableActionBlock"}
                      placement={"bottomRight"}
                    >
                      <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                        <TheeDotsIcon />
                      </a>
                    </Dropdown>
                    <div className="icon-block">
                      <VideoGroup />
                    </div>
                    <h4 className="word-break-common">
                      {data?.name
                        .split(" ")
                        .map((letter, index) => letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase())
                        .join(" ")}
                    </h4>
                  </div>
                </div>
              </>
            );
          })}
        </div>
        {/* <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={folderNames?.length}
          className="text-center mt-3"
        /> */}
      </div>
    </>
  );
};
export default AddClients;
